var map = {
	"./nage-no-kata/Harai-goshi.gif": "./src/pages/kata_techniques/nage-no-kata/Harai-goshi.gif",
	"./nage-no-kata/Kata-guruma.gif": "./src/pages/kata_techniques/nage-no-kata/Kata-guruma.gif",
	"./nage-no-kata/Okuri-ashi-harai.gif": "./src/pages/kata_techniques/nage-no-kata/Okuri-ashi-harai.gif",
	"./nage-no-kata/Sasae-tsurikomi-ashi.gif": "./src/pages/kata_techniques/nage-no-kata/Sasae-tsurikomi-ashi.gif",
	"./nage-no-kata/Seoi-nage.gif": "./src/pages/kata_techniques/nage-no-kata/Seoi-nage.gif",
	"./nage-no-kata/Sumi-gaeshi.gif": "./src/pages/kata_techniques/nage-no-kata/Sumi-gaeshi.gif",
	"./nage-no-kata/Tomoe-nage.gif": "./src/pages/kata_techniques/nage-no-kata/Tomoe-nage.gif",
	"./nage-no-kata/Tsurikomi-goshi.gif": "./src/pages/kata_techniques/nage-no-kata/Tsurikomi-goshi.gif",
	"./nage-no-kata/Uchi-mata.gif": "./src/pages/kata_techniques/nage-no-kata/Uchi-mata.gif",
	"./nage-no-kata/Uki-goshi.gif": "./src/pages/kata_techniques/nage-no-kata/Uki-goshi.gif",
	"./nage-no-kata/Uki-otoshi.gif": "./src/pages/kata_techniques/nage-no-kata/Uki-otoshi.gif",
	"./nage-no-kata/Uki-waza.gif": "./src/pages/kata_techniques/nage-no-kata/Uki-waza.gif",
	"./nage-no-kata/Ura-nage.gif": "./src/pages/kata_techniques/nage-no-kata/Ura-nage.gif",
	"./nage-no-kata/Yoko-gake.gif": "./src/pages/kata_techniques/nage-no-kata/Yoko-gake.gif",
	"./nage-no-kata/Yoko-guruma.gif": "./src/pages/kata_techniques/nage-no-kata/Yoko-guruma.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/pages/kata_techniques sync recursive ^\\.\\/.*\\.gif$";